import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-contrato-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class ContratoTabComponent{
	@Input() desativado:boolean = false;;
}
